const r=function(){for(var r=arguments.length,n=new Array(r),t=0;t<r;t++)n[t]=arguments[t];return n.filter((r=>!!r)).join(" ")};export{r as classNames};
